import React from 'react';

import Header from '../partials/Header';
import HeroAdioryx from '../partials/HeroAdioryx';
import AdioryxComponent from '../partials/AdioryxComponent';
import Cta from '../partials/Cta';
import Footer from '../partials/Footer';

function Adioryx() {
  return (
    <div className="flex flex-col min-h-screen overflow-hidden">

      {/*  Site header */}
      <Header />

      {/*  Page content */}
      <main className="grow">

        {/*  Page sections */}
        <HeroAdioryx />
        <AdioryxComponent />
        <Cta />

      </main>

      {/*  Site footer */}
      <Footer />

    </div>
  );
}

export default Adioryx;